import { render, staticRenderFns } from "./ComNar.vue?vue&type=template&id=652a3137&scoped=true&"
import script from "./ComNar.vue?vue&type=script&lang=js&"
export * from "./ComNar.vue?vue&type=script&lang=js&"
import style0 from "./ComNar.vue?vue&type=style&index=0&id=652a3137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a3137",
  null
  
)

export default component.exports